import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { BsCreditCard } from 'react-icons/bs';
import { TiDelete } from 'react-icons/ti';
import { Button } from '../components/input';
import { Loading } from '../components/loading';
import { SectionCard } from '../components/card';
import { LeftNav } from '../components/nav';
import { AddPaymentMethod } from '../components/billing';
import { Modal } from '../components/modal';
import { useCredits, useGlobal } from '../state';

const centerStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0',
  gap: 4,
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
};

const AddCardModal = () => {
  const { refreshUser } = useGlobal();
  const [close, setClose] = useState();

  const handleSuccess = async () => {
    await refreshUser();
    setClose(true);
  };

  return (
    <Modal close={close}>
      <Button>Add Payment Method</Button>
      <div style={{ width: 500 }}>
        <AddPaymentMethod onSuccess={handleSuccess} />
      </div>
    </Modal>
  );
};

const CardDisplay = ({}) => {
  const { user, refreshUser, fox } = useGlobal();
  const [loading, setLoading] = useState();
  const last4 = user?.paymentMethodLast4;

  const handleDelete = async (e) => {
    e.preventDefault();
    console.log('delete card', user, last4);

    setLoading(true);
    await fox.call('DELETE', '/api/user/stripe/card');
    await refreshUser();
    setLoading(false);
  };

  return (
    <div
      style={{
        borderRadius: 8,
        padding: '8px 12px',
        background: '#eee',
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '90%',
        fontWeight: 'bold',
        width: 200,
      }}
    >
      <BsCreditCard size={20} />
      <div>{last4 ? <>&bull; &bull; &bull; &bull; {last4}</> : 'Unknown card'}</div>
      {loading ? <Loading size="sm" /> : <TiDelete style={{ cursor: 'pointer' }} size={20} onClick={handleDelete} />}
    </div>
  );
};

export default function Billing() {
  const { user } = useGlobal();
  const { credits } = useCredits();

  return (
    <LeftNav>
      <div style={{ display: 'flex', gap: 20 }}>
        <SectionCard title="Remaining Credits">
          <div style={centerStyle}>
            <div style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>
              {!credits?.balance && <Loading />}
              {credits?.balance && <span>${(credits?.balance?.remaining / 1000).toFixed(2)}</span>}
            </div>
            <div></div>
          </div>
        </SectionCard>

        <SectionCard title="Payment Method">
          <div style={centerStyle}>
            {user && !user.paymentMethodId && <AddCardModal />}
            {user && user.paymentMethodId && <CardDisplay />}
          </div>
        </SectionCard>
      </div>

      {/*
      <pre>{JSON.stringify(credits, null, 2)}</pre>
      <pre>{JSON.stringify(user, null, 2)}</pre>
      */}
    </LeftNav>
  );
}
